import React from 'react';

const Authentication: React.FC = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Authentication Management</h1>
      <div className="card">
        <p>Authentication endpoints and user management will be implemented here.</p>
      </div>
    </div>
  );
};

export default Authentication; 